import { render, staticRenderFns } from "./SnackBarErrors.vue?vue&type=template&id=35cb7904&"
import script from "./SnackBarErrors.vue?vue&type=script&lang=js&"
export * from "./SnackBarErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports